export default {"src":"//_next/static/media/star.27ec9cfa.svg","height":76,"width":76,"blurWidth":0,"blurHeight":0};